<div class="pagination">
  <button
    class="icon-medium pi pi-angle-left"
    (click)="previousPage()"
    type="button"
    aria-label="Previous page"
  ></button>
  <span class="pagination-info">
    @if (pagination.page > 3) {
      <span>
        <button class="pagination-number" (click)="specificPage(0)">1</button>
        <span>...</span>
      </span>
    }
    @for (page of availableButtons; track page) {
      <button
        class="pagination-number"
        (click)="specificPage(page)"
        [ngClass]="page === pagination.page ? 'selected' : ''"
      >
        {{ page + 1 }}
      </button>
    }

    @if (showLastButtonOption) {
      <span>
        <span> ... </span>
        <button
          class="pagination-number"
          (click)="specificPage(pagination.total - 1)"
        >
          {{ pagination.total }}
        </button>
      </span>
    }
  </span>
  <span class="pagination-mobile">
    Página {{ pagination.page + 1 }} de {{ pagination.total }}
  </span>
  <button
    class="icon-medium pi pi-angle-right"
    (click)="nextPage()"
    type="button"
    aria-label="Next page"
  ></button>
  <p class="pagination-text-14">Mostrar</p>
  <form [formGroup]="formPagination">
    <app-select
      [formControl]="formPagination | handleFormControl: 'size'"
      [options]="pageSizes"
      [variant]="'compact'"
      (selectedOptionChange)="updatePageSize($event)"
    ></app-select>
  </form>
  <p class="pagination-text-12">Filas por página</p>
</div>
